import { useAuthStore } from '@/stores/authStore';

/**
 * Plan capability checks. The backend sends `capabilities` (an array of gated
 * feature keys) on the authenticated user. When it's absent (e.g. an older
 * session before this feature shipped), we allow access — the backend still
 * enforces the real restriction.
 */
export default function useCapabilities() {
  const authStore = useAuthStore();

  const has = (capability) => {
    if (!capability) {
      return true;
    }

    const capabilities = authStore.user?.capabilities;

    if (!Array.isArray(capabilities)) {
      return true;
    }

    return capabilities.includes(capability);
  };

  // Whether a menu item / route (with optional meta.capability) is allowed.
  const canAccessMeta = (meta = {}) => has(meta?.capability);

  // Where to send a user after auth / when navigating "home" — Home itself
  // for tiers that have it, otherwise the tier-appropriate default tab.
  const defaultLandingRoute = () => (has('home') ? '/app' : '/app/my-logs');

  return {
    has,
    canAccessMeta,
    defaultLandingRoute
  };
}
